import React, { useState, useContext } from 'react';
import axios from 'axios';
import { GoogleLogin } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';
import '../assets/css/style.bundle.css'
import { LoadingContext } from './LoadinContext';

const GoogleSignInPage = () => {

    const navigate = useNavigate();
    const { loadingGoogle, setLoadingGoogle } = useContext(LoadingContext);
    const [errorGoogle, setErrorGoogle] = useState(false);
    
    const handleLoginSuccess = async (response) => {
        setLoadingGoogle(true);
        try {
            setLoadingGoogle(true);
            localStorage.setItem('loadingGoogle', true);
            const googleToken = response.credential;
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/auth/google/client-login?id_token=${googleToken}&app_rqst=true`);
            if (res.data.status === 200) {
                localStorage.setItem('auth', JSON.stringify(res.data.user));
                localStorage.setItem('loadingGoogle', false);
                setLoadingGoogle(false);
                navigate('/');
            } else {
                setErrorGoogle(res.data.message);
                setLoadingGoogle(false);
                localStorage.setItem('errorGoogle', res.data.message);
                navigate('/');
            }
        } catch (err) {
            setErrorGoogle('An error occurred during the login process. Please try again.');
            setLoadingGoogle(false);
            localStorage.setItem('errorGoogle', 'An error occurred during the login process. Please try again.'); 
            navigate('/');
        }
    };

    const handleLoginFailure = (error) => {
        console.error('Login Failed:', error);
        alert('Google Sign-In failed. Please try again.');
    };

    return (
        <div className="parent-container">
        <GoogleLogin  loadingGoogle={loadingGoogle} 
            onSuccess={handleLoginSuccess}
            onError={handleLoginFailure}
            useOneTap
            className="google-sign-in-btn" 
            render={renderProps => (
                <button onClick={renderProps.onClick} disabled={renderProps.disabled}>This is my custom Google button</button>
              )}
             
        /></div>
    );
};

export default GoogleSignInPage;
